//settings
import React from "react";

//styles
import StylesFooter from "./footer.module.scss";

//assets
import logoB from "../../assets/logo_images/logoB.png";
	
const FooterComponent: React.FC = () => {

    return (
        <>
            <div className={[StylesFooter.__main_footer_container].join(' ')}>
                <div className={[StylesFooter.__footer].join(' ')}>
                    <div className={[StylesFooter.__logo].join(' ')}>
                        <div className={[StylesFooter.__img].join(' ')}>
                            <img src={logoB} alt="logo" />
                        </div>
                    </div>
                    <div className={[StylesFooter.__credits].join(' ')}>
                        <span>Desarrollado por Samuel González Lunar (2025) - Todos los Derechos Reservados </span>
                    </div>
                </div>
           </div>
        </>
    );
}

export default FooterComponent;